import {createAction} from '@reduxjs/toolkit'
import {getEventId} from '@wix/wix-events-commons-statics'
import {openDialogModal} from '../../../../commons/services/modal'
import {getEvent, isDemoEvent} from '../selectors/event'
import {createAsyncAction} from '../services/redux-toolkit'
import {GetState} from '../types/state'

export const toggleAgreePolicies = createAction('TOGGLE_AGREE_POLICIES')

export const getPolicies = createAsyncAction<
  {policies: wix.events.Policy[]; policyAgreementToken?: string},
  {showAlert: boolean}
>(
  'GET_POLICIES',
  async (_, {getState, extra: {serverApi}}) => {
    const state = getState()
    const event = getEvent(state)

    return serverApi.getPolicies(getEventId(event))
  },
  {
    condition: (_, {getState}) => {
      return !isDemoEvent(getState())
    },
  },
)

interface OpenPolicyModalArgs {
  policyId: string
  returnFocusElement: string
}
export const openPolicyModal =
  ({policyId, returnFocusElement}: OpenPolicyModalArgs) =>
  (dispatch: Function, getState: GetState) => {
    const state = getState()
    const event = getEvent(state)
    dispatch(
      openDialogModal({
        type: 'policy',
        params: {
          policyId,
          eventId: getEventId(event),
        },
        returnFocusElement,
      }),
    )
  }
